import { render, staticRenderFns } from "./CommissionComponent.vue?vue&type=template&id=22521fb0&scoped=true"
import script from "./CommissionComponent.vue?vue&type=script&lang=js"
export * from "./CommissionComponent.vue?vue&type=script&lang=js"
import style0 from "./CommissionComponent.vue?vue&type=style&index=0&id=22521fb0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22521fb0",
  null
  
)

export default component.exports